import React from "react";
import PropTypes from "prop-types";

/**
 * AvatarPreview
 * Componente premium para exibição de fotos de perfil com fallback para iniciais.
 */
const AvatarPreview = ({ src, alt, size = "md", className = "", fallbackType = "initials" }) => {

    // Configurações de tamanho baseadas nas classes do NEO Admin
    const sizeClasses = {
        xs: "avatar-xs",
        sm: "avatar-sm",
        md: "avatar-md",
        lg: "avatar-lg",
        xl: "avatar-xl"
    };

    const wrapperClass = `${sizeClasses[size] || "avatar-md"} ${className}`;

    if (src) {
        return (
            <div className={wrapperClass}>
                <img
                    src={src}
                    alt={alt}
                    className="img-fluid rounded-circle w-100 h-100"
                    style={{ objectFit: "cover" }}
                />
            </div>
        );
    }

    // Fallback: Iniciais do nome ou ícone
    const initials = (alt && fallbackType === "initials") ? alt.charAt(0).toUpperCase() : "";

    return (
        <div className={wrapperClass}>
            <span className="avatar-title rounded-circle bg-light-soft text-primary font-size-18">
                {initials || <i className="mdi mdi-account"></i>}
            </span>
        </div>
    );
};

AvatarPreview.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
    className: PropTypes.string
};

export default AvatarPreview;
